<span [style.visibility]="readyToDisplayQuill()?'visible':'hidden'">
  @if (readyToInitializeQuill()) {
    <quill-editor [readOnly]="isReadOnly" (onEditorCreated)="onEditorCreated($event)" [modules]="modules" [placeholder]="'Welcome to Scrivendium. Write your content here!'" [theme]="'snow'" [style]="{ height: '100%', width: '100%'}"/>
  }
</span>

@if (selectedComment) {
  <p-dialog appendTo="body" header="Add Comment" [modal]="true" [(visible)]="showAddCommentDialog" [closable]="false" [style]="{ width: '40%'}">
    <comment isNew="true" [user]="dataService.user()" [comment]="selectedComment()"/>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="showAddCommentDialog.set(false);closeComment()"></button>
      <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" (click)="showAddCommentDialog.set(false);saveNewComment()"></button>
      <!-- If this isn't a new comment, then "resolve" needs to be available. -->
    </ng-template>
  </p-dialog>
}

@if (selectedComment) {
  <p-dialog appendTo="body" [draggable]="true" [resizable]="true"  [header]="showMultiple?'All Comments':'View Comment'" [modal]="!showMultiple" [(visible)]="showComments" (onShow)="markViewed()" [closable]="false" [style]="{ width: '40%'}">
    <!-- span class="hidden md:block p-text-secondary mb-5">Show All <p-inputSwitch [(ngModel)]="showMultiple" /></span -->
    @if (!showMultiple) {
      <comment [isNew]="false" [user]="dataService.user()" [baseReply]="newReply" [comment]="selectedComment()" />
    }
    <ng-template pTemplate="footer">
      <button  pButton pRipple label="Close" icon="pi pi-times" class="p-button-text" (click)="showComments.set(false);closeNewReply()"></button>
      <button  pButton pRipple label="Save Reply" icon="pi pi-check" class="p-button-text" (click)="showComments.set(false);saveNewReply()"></button>
      <!-- If this isn't a new comment, then "resolve" needs to be available. -->
    </ng-template>
  </p-dialog>
}
